import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["g",{"transform":"translate(1.5, 0)","key":"svg-0"}]]

const IconVolume4 = createReactComponent('outline', 'volume-4', 'Volume4', __iconNode);

export default IconVolume4;